@if (showSwitch) {
  <div class="persistent-flag-switch">
    <span class="persistent-flag-switch__text">Set persistent attribute to LD</span>
    <ftr-switch [value]="persistentFlagEnabled" (onValueChange)="onPersistentFlagChange($event)" />
  </div>
}
